import { useNavigate } from "react-router-dom";
import { FileText } from "lucide-react";
import { toast } from "sonner";
import { http, formatApiError } from "../lib/api";

const eur = (n) => (n || 0).toLocaleString("fr-FR", { style: "currency", currency: "EUR" });
const parisNow = () => { const d = new Date(new Date().toLocaleString("en-US", { timeZone: "Europe/Paris" })); const p = (n) => String(n).padStart(2, "0"); return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`; };
const counted = (m, now) => m?.enabled && (!m.end_at || now < m.end_at);

export const monthlyTotal = (f, catalog) => {
  if (f.free) return { ...monthlyTotal({ ...f, free: false }, catalog), base: 0, opts: 0, users: 0, total: 0, full: monthlyTotal({ ...f, free: false }, catalog).total };
  const now = parisNow();
  const base = (f.tiers || []).length ? Number(f.tiers[f.tier || 0]?.price || 0) : Number(f.base_price || 0);
  const paid = catalog.optional.filter((o) => { const m = f.modules[o.code]; return counted(m, now) && !(m.trial_until && m.trial_choice !== "keep") && Number(m.price) > 0; });
  const opts = paid.reduce((s, o) => s + Number(f.modules[o.code].price), 0);
  const users = Math.max(0, Number(f.max_users || 1) - 1) * Number(f.user_price || 0);
  const later = paid.filter((o) => f.modules[o.code].start_at && f.modules[o.code].start_at > now).map((o) => o.label);
  return { base, opts, users, total: base + opts + users, n: paid.length, later };
};

export const MonthlyTotal = ({ f, catalog }) => {
  const t = monthlyTotal(f, catalog);
  const annual = f.billing_cycle === "annual";
  const disc = Number(f.annual_discount_pct || 0);
  return (
    <div className="sticky bottom-0 z-10 mt-4 rounded-lg border border-[#C9962E]/50 bg-gradient-to-r from-[#0B2A7A] to-[#12358f] text-white px-5 py-3 flex flex-wrap items-center gap-x-6 gap-y-1 shadow-lg" data-testid="company-monthly-total">
      <span className="text-[11px] uppercase tracking-widest text-[#F6D88A] font-bold">Abonnement calculé</span>
      <span className="text-xs text-blue-100">Base {eur(t.base)} · {t.n} option(s) {eur(t.opts)} · utilisateurs {eur(t.users)}</span>
      <span className="ml-auto font-display text-2xl font-extrabold" data-testid="company-monthly-total-value">{f.free ? `Offert${t.full ? ` (au lieu de ${eur(t.full)} HT / mois)` : ""}` : `${eur(t.total)} HT / mois`}</span>
      {t.later.length > 0 && <span className="w-full text-xs text-[#F6D88A]" data-testid="company-total-later">Inclut {t.later.length} option(s) qui démarrent plus tard : {t.later.join(", ")}</span>}
      {annual && !f.free && <span className="w-full text-right text-xs text-blue-100" data-testid="company-annual-total">soit {eur(t.total * 12 * (1 - disc / 100))} HT / an{disc ? ` (remise ${disc} %)` : ""}</span>}
    </div>
  );
};

export const CreateQuoteBtn = ({ company, onBeforeLeave, beforeCreate }) => {
  const nav = useNavigate();
  const go = async () => {
    try {
      if (beforeCreate && !(await beforeCreate())) return; const r = await http.post(`/superadmin/companies/${company.id}/quote`); toast.success(`Devis ${r.data.number || ""} créé et rangé dans Devis`); onBeforeLeave?.(); nav(`/super/facturation?edit=${r.data.id}`); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  return <button type="button" onClick={go} className="mr-auto inline-flex items-center gap-2 px-4 py-2 text-sm rounded-md border border-[#C9962E] text-[#8a6416] font-semibold hover:bg-amber-50 transition-colors" data-testid="company-create-quote-btn"><FileText className="h-4 w-4" />Créer un devis</button>;
};
